export const formatNewLines = str =>
  str.split(/\n|\r/).reduce((acc, part, idx, arr) => {
    acc.push(part);
    if (idx < arr.length - 1) {
      acc.push(<br key={`${idx}`} />);
    }
    return acc;
  }, []);

export const stripNbsp = str => str.replaceAll(/&nbsp;/gi, '');

/** Remove <br> from beginning and end of string */
export const trimNewLines = str =>
  str.replaceAll(/^(\s+<br( \/)?>)*|(<br( \/)?>\s)*$/gm, '');
